import { PriceListNoteApiDto } from '@lx/shared/api';

export const SubjectEnum = PriceListNoteApiDto.SubjectEnum;
export type SubjectEnum = PriceListNoteApiDto.SubjectEnum;
